import { render, staticRenderFns } from "./comp_DeliveryOptionCardContent.vue?vue&type=template&id=6517b4d3&scoped=true&"
import script from "./comp_DeliveryOptionCardContent.vue?vue&type=script&lang=js&"
export * from "./comp_DeliveryOptionCardContent.vue?vue&type=script&lang=js&"
import style0 from "./comp_DeliveryOptionCardContent.vue?vue&type=style&index=0&id=6517b4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6517b4d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VIcon,VRadio})
